import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Menu from 'antd/lib/menu';
import _ from 'lodash';

import { permissionService } from 'shared/services';

import { FormattedMessage } from 'react-intl';

import { DeliveryMenu as DeliveryMenuIcon } from 'components/Icons';
import deliveryRoute from '../../route';

import text from './DeliveryMenu.component.translation';

const { SubMenu } = Menu;

const DeliveryMenu = props => {
  const { location, onLink } = props;
  const { checkPermission } = permissionService;
  const pathname = _.get(location, 'pathname', '');

  let orderList;
  if (pathname === deliveryRoute.ORDER_LIST) {
    orderList = deliveryRoute.ORDER_LIST;
  } else if (pathname.includes(deliveryRoute.ORDER_DETAIL.replace(':id', ''))) {
    orderList = pathname;
  }
  let partnerList;
  if (pathname === deliveryRoute.PARTNER_LIST) {
    partnerList = deliveryRoute.PARTNER_LIST;
  } else if (
    pathname.includes(deliveryRoute.PARTNER_DETAIL.replace(':id', ''))
  ) {
    partnerList = pathname;
  }

  let clientList;
  if (pathname.includes(deliveryRoute.CLIENT_LIST)) {
    clientList = pathname;
  }

  const canAccessOrderList = checkPermission('Order List:read', true);
  const canAccessPartnerList = checkPermission('Partner Management:read', true);
  const canAccessClientList = checkPermission('Client:read', true);

  return (
    <SubMenu
      key="delivery"
      title={
        <span className="center-content">
          <DeliveryMenuIcon />
          <span>
            <FormattedMessage {...text.danaDelivery} />
          </span>
        </span>
      }
    >
      {canAccessOrderList && (
        <Menu.Item key={orderList}>
          <Link to={deliveryRoute.ORDER_LIST} onClick={onLink}>
            <span>
              <FormattedMessage {...text.orderList} />
            </span>
          </Link>
        </Menu.Item>
      )}
      {canAccessPartnerList && (
        <Menu.Item key={partnerList}>
          <Link to={deliveryRoute.PARTNER_LIST} onClick={onLink}>
            <span>
              <FormattedMessage {...text.partnerList} />
            </span>
          </Link>
        </Menu.Item>
      )}
      {canAccessClientList && (
        <Menu.Item key={clientList}>
          <Link to={deliveryRoute.CLIENT_LIST} onClick={onLink}>
            <span>
              <FormattedMessage {...text.clientList} />
            </span>
          </Link>
        </Menu.Item>
      )}
    </SubMenu>
  );
};

DeliveryMenu.propTypes = {
  location: PropTypes.object,
  onLink: PropTypes.func,
};

export default DeliveryMenu;
